var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 53 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 0C48.2467 0 52.5 4.2533 52.5 9.5V40C52.5 45.2467 48.2467 49.5 43 49.5H9.5C4.2533 49.5 0 45.2467 0 40V9.5C3.22139e-08 4.2533 4.2533 0 9.5 0H43ZM11 46.5H43C46.5899 46.5 49.5 43.5899 49.5 40V9.5C49.5 5.91015 46.5899 3 43 3H11V46.5ZM44 37H16V31H44V37ZM44 21H16V13H44V21Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.aaa52442f5fa66e826f6ae89ae75043c.svg";
export { ForwardRef as ReactComponent };